<template>
  <div class="pack_base">
    <div class="pack">
      <div class="form-group">
        <select class="size" :value="pack.size_id" @input="inputSize($event.target.value)">
          <option value="">サイズ(単価[税別])</option>
          <option :value="size.id" v-for="size in sizes" :key="'size_'+size.name">
            {{size.name}}
            ({{ basePrice() + size.add_price | currency}})
          </option>
        </select>
        <label v-if="pack.size_id">
          <span class="label"> x 数量</span>
          <select class="value" :value="pack.value" @input="inputValue($event.target.value)">
            <option v-for="n in 99" :value="n" :key="'value_'+n">{{n}}</option>
          </select>
        </label>
      </div>
<!--      <div class="form-group add" v-if="pack.value > 0">-->
<!--        <template v-if="input_letter_number">-->
<!--          <label>-->
<!--            <span class="label">番号</span>-->
<!--            <select class="number" :value="pack.number" @input="inputNumber($event.target.value)">-->
<!--              <option value="">無し </option>-->
<!--              <option v-for="n in 99" :key="'number_'+n">{{n}}</option>-->
<!--            </select>-->
<!--          </label>-->
<!--        </template>-->
<!--        <input type="text" :value="pack.name" class="name" placeholder="個人名"-->
<!--               v-if="input_letter_name"  @input="inputName($event.target.value)">-->
<!--      </div>-->
    </div>
    <button class="delete" @click="deletePack" v-if="cart.packs.length>1"><span>×</span></button>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: 'pack',
    props: ['pack', 'sizes', 'basePrice', 'index'],
    data(){
      return {
        selectedSize: null
      }
    },
    created () {
      this.initialize();
    },
    computed: {
      ...mapState(['cart']),
      selected () {
        return {
          size: this.pack.size_id,
          value: this.pack.value
        }
      },
      input_letter_number: function(){
        for (var i = 0; i < this.$store.state.cart.letters.length; i++){
          var letter = this.$store.state.cart.letters[i];
          if (letter.hasOwnProperty('decoration')){
            if (letter.sync_code == "number" && letter.decoration.name != "なし"){
              return true;
            }
          }
        }
        return false;
      },
      input_letter_name(){
        for (var i = 0; i < this.$store.state.cart.letters.length; i++){
          var letter = this.$store.state.cart.letters[i];
          if (letter.hasOwnProperty('decoration')){
            if (letter.sync_code == "name" && letter.decoration.name != "なし"){
              return true;
            }
          }
        }
        return false;
      },
    },
    methods: {
      initialize () {
        const selectedSize = this.sizes.find(size => size.id === this.pack.size_id);
        if (selectedSize) {
          this.selectedSize = selectedSize.id;
        } else {
          this.selectedSize = '';
        }
      },
      inputSize(size_id){
        const selectedSize = this.sizes.find(size => size.id === Number(size_id));
        if (selectedSize) {
          this.$store.commit('setCartPack', {
              pack: {
                pack_price: selectedSize.add_price,
                size_name: selectedSize.name,
                size_id: selectedSize.id,
                value: (this.pack.value) ? this.pack.value : 1,
                name: this.pack.name,
                number: this.pack.number,
              },
              index: this.index
            }
          );
          this.$emit('packInput');  // 次の画面にいけるようにする
        }
      },
      inputValue(value){
        this.$store.commit('setCartPack', {
            pack: {
              pack_price: this.pack.pack_price,
              size_name: this.pack.size_name,
              size_id: this.pack.size_id,
              value: Number(value),
              name: this.pack.name,
              number: this.pack.number,
            },
            index: this.index
          }
        );
      },
      // inputNumber(value){
      //   this.$store.commit('setCartPack', {
      //       pack: {
      //         pack_price: this.pack.pack_price,
      //         size_name: this.pack.size_name,
      //         size_id: this.pack.size_id,
      //         value: this.pack.value,
      //         name: this.pack.name,
      //         number: value,
      //       },
      //       index: this.index
      //     }
      //   );
      // },
      // inputName(value){
      //   this.$store.commit('setCartPack', {
      //       pack: {
      //         pack_price: this.pack.pack_price,
      //         size_name: this.pack.size_name,
      //         size_id: this.pack.size_id,
      //         value: this.pack.value,
      //         name: value,
      //         number: this.pack.number,
      //       },
      //       index: this.index
      //     }
      //   );
      // },
      deletePack(){
        this.$store.commit('deleteCartPack', this.pack)
      },
    },
    watch: {
      selectedSize () {
        this.inputSize();
      }
    }
  }
</script>

<style scoped>
  select.value{
    width: 5rem;
  }
  .pack_base{
    display: flex;
  }
  .pack {
    position: relative;
    padding: 10px;
    background-color: white;
    transition: .4s;
    left: 0px;
    box-shadow: rgba(0, 0, 0, 0.4) 0px 0px 0px;
    touch-action:pan-y!important;
    flex-grow: 1;
  }
  .pack .size {
    font-size: 16px;
    width: 11.5rem;
  }
  .pack label span.label{
    vertical-align: sub;
  }
  button.delete{
    background-color: #900000;
    width: 35px !important;
    height: 35px;
    border: 0;
    border-radius: 20%;
    margin: 10px;
    color: #ffffff;
    font-weight: bold;
    text-align:center;
  }
  button.delete>span{
    font-size: 24px;
  }

</style>
